module.exports = __webpack_public_path__ + "img/smiley.c53b8e3a.svg";